import React from 'react';
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';
import { useSectionTracking, useInteractionTracking } from '../hooks/useFirebase';
import './Hero.css';

const Hero = () => {
  const sectionRef = useSectionTracking('hero-section');
  const { trackClick } = useInteractionTracking();

  const scrollToContact = () => {
    trackClick('hero-cta-button', { action: 'scroll_to_contact' });
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };


  return (
    <section className="hero" ref={sectionRef}>
      <div className="hero-background">
        <div className="hero-visual-bg">
          <div className="gradient-orb orb-1"></div>
          <div className="gradient-orb orb-2"></div>
          <div className="gradient-orb orb-3"></div>

          <div className="neural-network">
            <div className="neural-node node-1"></div>
            <div className="neural-node node-2"></div>
            <div className="neural-node node-3"></div>
            <div className="neural-connection connection-1"></div>
            <div className="neural-connection connection-2"></div>
          </div>

          <div className="migraine-aura">
            <div className="aura-ring aura-ring-1"></div>
            <div className="aura-ripple aura-ripple-1"></div>
          </div>

          <div className="floating-elements">
            <div className="floating-particle particle-1"></div>
            <div className="floating-particle particle-2"></div>
            <div className="floating-particle particle-3"></div>
            <div className="floating-particle particle-4"></div>
            <div className="floating-particle particle-5"></div>
            <div className="floating-particle particle-6"></div>
            <div className="floating-particle particle-7"></div>
            <div className="floating-particle particle-8"></div>
            <div className="floating-particle particle-9"></div>
            <div className="floating-particle particle-10"></div>
            <div className="floating-particle particle-11"></div>
            <div className="floating-particle particle-12"></div>
            <div className="floating-circle circle-1"></div>
            <div className="floating-circle circle-2"></div>
            <div className="floating-circle circle-3"></div>
            <div className="floating-circle circle-4"></div>
            <div className="floating-circle circle-5"></div>
            <div className="floating-circle circle-6"></div>
            <div className="floating-bg-circle bg-circle-1"></div>
            <div className="floating-bg-circle bg-circle-2"></div>
            <div className="floating-bg-circle bg-circle-3"></div>
            <div className="floating-bg-circle bg-circle-4"></div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="hero-content">
          <motion.div
            className="hero-text"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <motion.span
              className="hero-eyebrow"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              Phase 1 · Protocol Validation
            </motion.span>

            <motion.h1
              className="hero-title"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              Can migraines be
              <br />
              <span className="highlight">predicted?</span>
            </motion.h1>

            <motion.p
              className="hero-subtitle"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              We're a research team exploring that question. To validate our approach,
              we're running a short study before scaling up to a full trial.

            </motion.p>

            <motion.div
              className="hero-buttons"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.8 }}
            >
              <motion.button
                className="btn btn-primary btn-large"
                onClick={scrollToContact}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                Get Involved
                <FaArrowRight className="btn-icon" />
              </motion.button>
            </motion.div>

            <motion.div
              className="hero-stats"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 1 }}
            >
              <div className="stat">
                <div className="stat-number">5 min</div>
                <div className="stat-label">Per Day</div>
              </div>
              <div className="stat">
                <div className="stat-number">~1 mo</div>
                <div className="stat-label">Commitment</div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
